export enum DeviceType {
    MOBILE = "mobile",
    TABLET = "tablet",
}

export enum OS {
    IOS = "iOS",
    ANDROID = "Android",
    MACOS = "Mac OS",
}

export interface UAData {
    device: { type: DeviceType };
    os: { name: OS };
}

export interface UADevice extends UAParser.IDevice {
    type: DeviceType;
}

export interface UAOS extends UAParser.IOS {
    name: OS;
}
